import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import ErrorPage from '../widgets/ErrorPage';

class NotFoundPage extends Component {
	render() {
		return (
			<ErrorPage className="ForbiddenPage">
				<p>You attempted to edit or modify a resource that you do not have access to :'(.</p>
				<p>
					Please try again or return to the <Link to="/">Home</Link> page.
				</p>
				<p>
					Please let our{' '}
					<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
						support team
					</a>{' '}
					know if this keeps happening.
				</p>
			</ErrorPage>
		);
	}
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/chrome/ForbiddenPage.js